import { render, staticRenderFns } from "./HealthcheckGroups.vue?vue&type=template&id=590c3d6e&scoped=true&"
import script from "./HealthcheckGroups.vue?vue&type=script&lang=js&"
export * from "./HealthcheckGroups.vue?vue&type=script&lang=js&"
import style0 from "./HealthcheckGroups.vue?vue&type=style&index=0&id=590c3d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c3d6e",
  null
  
)

export default component.exports